export function verificationDescription(valid: boolean) {
  return valid ? "Verified" : "Pending verification";
}
